import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import "./DataLinks.css";
import { Skeleton } from "@progress/kendo-react-indicators";
import { useSelector } from "react-redux";
import { formatFieldValue } from "../SideBar/Results/Identify/FeatureDescription";

const DataLinkList = ({ dataLinkConfig, setDataLink }) => {
    const dataLinkData = useSelector((state) => state.resultsData.dataLinkData);

    return (
        <>
            <h3 className="datalinks-header">Related Records</h3>
            {/* If waiting response */}
            {Object.keys(dataLinkData).length === 0 ? (
                <>
                    <Skeleton shape={"text"} style={{ width: "100px" }} />
                    <Skeleton shape={"text"} style={{ width: "100px" }} />
                    <Skeleton shape={"text"} style={{ width: "100px" }} />
                    <Skeleton shape={"text"} style={{ width: "100px" }} />
                </>
            ) : // If response did not have data property
            dataLinkData.data === "No Data" ? (
                <div>Error fetching data</div>
            ) : // If all responses had empty data array
            Object.values(dataLinkData?.data).every((d) => d.length === 0) ? (
                <i>No Related Records</i>
            ) : (
                <>
                    {dataLinkConfig.map((d) => {
                        const data = dataLinkData.data[d.DataLinkID];
                        return (
                            <LinkList
                                data={data}
                                dataLinkConfig={d}
                                key={d.DataLinkID}
                                setDataLink={setDataLink}
                            />
                        );
                    })}
                </>
            )}
        </>
    );
};

export default DataLinkList;

export const LinkList = ({ data, dataLinkConfig, setDataLink }) => {
    const openDataLink = (data) => {
        setDataLink(() => data);
    };

    return data.length > 0 ? (
        <div style={{ paddingLeft: "3px" }}>
            <h4 className="datalink-header">{dataLinkConfig.DisplayName}</h4>
            <div className="datalink-list">
                {data.map((d) => {
                    const key = Object.keys(d)[0];
                    return (
                        <div
                            className="datalink"
                            key={d[key]}
                            onClick={() => openDataLink(d)}>
                            {`${key} ${d[key]}`}
                        </div>
                    );
                })}
            </div>
        </div>
    ) : null;
};

export const DataLink = ({ dataLink, setDataLink }) => {
    return (
        <div id="data-link">
            <Button
                icon="close"
                onClick={() => setDataLink(undefined)}
                style={{ position: "absolute", right: "10px", top: "10px" }}
                fillMode="flat"
            />
            {Object.keys(dataLink).map((d) => {
                const displayValue = formatFieldValue({ Name: d }, dataLink);
                return (
                    <div key={d}>
                        <div className="results-field">{d}</div>
                        <div className="results-field-value">{displayValue}</div>
                    </div>
                );
            })}
        </div>
    );
};
